exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Flash{width:100%;height:260px;position:relative\n}\n.Flash .player{height:100%;width:100%\n}\n.Flash .hider{top:0\n}\n.Flash .label{text-align:center;flex:1 1 0;line-height:1.2;white-space:normal;word-wrap:normal\n}\n.Flash .hidden{display:none;visibility:\"hidden\"\n}\n.Flash .placeholder{height:100%;flex:1;display:flex;align-items:center;justify-content:center\n}", ""]);

// exports
